import React from 'react';

interface IColumnProps {
	children?: React.ReactNode;
	className?: string;
}

export const Column = ({ children, className }: IColumnProps) => (
	<div className={`md:flex-auto md:grow ${className}`}>{children}</div>
);
